import { GET_BOUND_POLICIES } from '../../constants/actions/policies';

export function getBoundPolicies(payload) {
    return {
        type: GET_BOUND_POLICIES,
        payload,
    };
}
